import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { CartProvider } from "@/lib/cart";
import { MemberAuthProvider, AdminAuthProvider } from "@/lib/auth";
import { SiteImagesProvider } from "@/lib/siteImages";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import CatalogPage from "@/pages/CatalogPage";
import Gallery from "@/pages/Gallery";
import ProductDetail from "@/pages/ProductDetail";
import MembersGate from "@/pages/MembersGate";
import MembersCatalog from "@/pages/MembersCatalog";
import MemberLogin from "@/pages/MemberLogin";
import MemberSignup from "@/pages/MemberSignup";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";

const StoreLayout = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <>
      <Header />
      <CartDrawer />
      <main className="min-h-[60vh]">
        <Outlet />
      </main>
      {!isHome && <Footer />}
    </>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, behavior: "instant" });
  }
  return null;
};

const App = () => (
  <div className="App">
    <BrowserRouter>
      <AdminAuthProvider>
        <MemberAuthProvider>
          <SiteImagesProvider>
            <CartProvider>
              <Toaster position="top-center" toastOptions={{ style: { background: "#0a0a0a", color: "#fff", border: "1px solid #fff" } }} />
            <Routes>
              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminOverview />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="subscribers" element={<AdminSubscribers />} />
              </Route>

              {/* Public store */}
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/tees" element={<CatalogPage category="tees" title="tees" edgeCapsule="SV25 · TEES 01" columns={4} />} key="tees-route" />
                <Route path="/headwear" element={<CatalogPage category="headwear" title="headwear" edgeCapsule="SV25 · CAPSULE 01" columns={4} />} />
                <Route path="/hoodies" element={<CatalogPage category="hoodies" title="hoodies" edgeCapsule="SV25 · KNIT 01" />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:orderNumber" element={<OrderSuccess />} />
                <Route path="/members" element={<MembersGate />} />
                <Route path="/members/login" element={<MemberLogin />} />
                <Route path="/members/signup" element={<MemberSignup />} />
                <Route path="/members/catalog" element={<MembersCatalog />} />
                <Route path="/members/product/:id" element={<ProductDetail membersOnly />} />
                <Route path="*" element={<div className="section-pad py-32 text-center"><h1 className="font-display text-6xl uppercase tracking-tighter">404</h1><p className="mt-4 text-sm text-black/60">Page not found</p></div>} />
              </Route>
            </Routes>
            </CartProvider>
          </SiteImagesProvider>
        </MemberAuthProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  </div>
);

export default App;
